import {
  MercuryAPI,
  AuthActions as WidgetAuthActions,
  openURL,
  widgetDispatch,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {all, call, put, takeLatest} from '@redux-saga/core/effects';
import {PayloadAction} from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import {Platform} from 'react-native';
import {persistor} from 'store';

import {Routes} from 'models/Navigation';

import {AuthActions, LogoutAction, LogoutMsg} from 'store/auth/auth.reducer';
import {OffersActions} from 'store/offers/offers.reducer';
import {ReservationsActions} from 'store/reservations/reservations.reducer';
import {navigationRef} from 'utils/navigation';
import {navigateToSignin} from 'utils/signin';

export function* handleLogout(action: PayloadAction<LogoutAction>) {
  const {msg, forwardUrl} = action.payload;
  if (msg === undefined) {
    /** No message means it's a soft logout eg. changeUser */
    return;
  }

  yield call(() => Cookies.remove('mfa_token'));

  WidgetAuthActions.clearUserInfo();
  /** Making sure that storage is emptied so the state doesn't persist after logout  */
  persistor.flush();

  // Note: Legacy call that is superceded by Universal Sign In.
  if (msg === LogoutMsg.LOGOUT && Platform.OS === 'web') {
    // yield call(MercuryAPI.unAuthenticateWeb, forwardUrl);
    Cookies.remove('sectoken');
    Cookies.remove('accountId');
    Cookies.remove('userInfoCookie');
    Cookies.remove('userSessionCookie');
    localStorage.removeItem('persist:mfa_shared_library');
    localStorage.removeItem('persist:myrewards');
    localStorage.removeItem('persist:myrewards_shared_library');
    // return;
  }

  // For timeout or non-web logout, use signin navigation
  const currentUrl = Platform.OS === 'web' ? window.location.search : '';
  const urlParams = new URLSearchParams(currentUrl);

  // For timeout: only set msg if no existing msg parameter (preserve passwordreset, etc.)
  // For other logout types: always set the msg
  if (msg === LogoutMsg.TIMEOUT) {
    if (!urlParams.has('msg')) {
      urlParams.set('msg', msg);
    }
  } else {
    urlParams.set('msg', msg);
  }

  if (forwardUrl) {
    urlParams.set('forwardUrl', forwardUrl);
  }

  const paramString = urlParams.toString();
  // Note: navigation's main isLoggedIn effect also calls navigateToSignIn
  // That useEffect strips the query parameters
  navigateToSignin(paramString);
}

export function* handleUserChange() {
  yield put(AuthActions.logout({}));

  if (Platform.OS === 'web') {
    if (window.isLegacyMyRewards) {
      return;
    }
  }

  const currentRoute = navigationRef?.current?.getCurrentRoute();
  if (currentRoute?.name === Routes.Main.Offers) {
    yield put(OffersActions.getOffers({}));
    yield put(ReservationsActions.getReservations());
  }
}

export default function* authSagas() {
  yield all([
    takeLatest(AuthActions.changeUser, handleUserChange),
    takeLatest(AuthActions.logout, handleLogout),
  ]);
}
